var map = {
	"./kingbronze.gif": 48381,
	"./kingbronze_attack.gif": 34372,
	"./kingbronze_ded.gif": 88179,
	"./kinggold.gif": 75387,
	"./kinggold_attack.gif": 88074,
	"./kinggold_ded.gif": 42429,
	"./kingsilver.gif": 9318,
	"./kingsilver_attack.gif": 16337,
	"./kingsilver_ded.gif": 17836,
	"./smolslime.gif": 83491,
	"./smolslime_attack.gif": 16834,
	"./smolslime_ded.gif": 79765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34971;